import React, { Component } from 'react';

import classes from './ClientInfo.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../../../components/UI/Backdrop/Backdrop';

class ClientInfo extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.show !== this.props.show ||
          nextProps.loading !== this.props.loading ||
          nextProps.children !== this.props.children;
  }

  render() {
    return (
      <Aux>
        <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
        <div
          className={classes.Modal}
          style={{transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                  opacity: this.props.show ? '1' : '0'}}>
            { this.props.children }
        </div>
      </Aux>
    );
  }
}

export default ClientInfo;



// WEBPACK FOOTER //
// ./src/containers/TrackingPage/ClientInfo/ClientInfo.js